import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/featured-products")({
  component: lazyRouteComponent(() => import("./-pages/admin.featured-products")),
  head: () => ({
    meta: [
      { title: "Featured Products · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
